<template>
  <a class="button"
     v-if="buttonContent.label"
     :href="buttonContent.url">
      {{ buttonContent.label }}
  </a>
</template>

<script>
export default {
  name: 'Button',
  props: {
    buttonContent: {
      type: Object,
      default: function () {
        return {
          url: '#',
          label: 'DOWIEDZ SIĘ WIECEJ',
        }
      }
    }
    // url: {
    //   type: String,
    //   default: "#"
    // },
    // label: {
    //   type: String,
    //   default: "DOWIEDZ SIĘ WIĘCEJ"
    // }
  }
}
</script>

<style lang="sass">
  @import 'src/assets/stylesheets/style.sass'
</style>
